// Under nginx's client_max_body_size (75M), which rejects larger bodies
// as a bare "Network Error". Keep in step with the live nginx config.
export const MAX_UPLOAD_MB = 70

const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024

export function totalSize (files) {
  return files.reduce((sum, file) => sum + file.size, 0)
}

export function exceedsUploadLimit (files) {
  return totalSize(files) > MAX_UPLOAD_BYTES
}
